import { BodyProject } from '../shared/types/project.interface';
import { apiService } from './index';

export const asyncGetProjects = async (
    projectIds?: string[],
    page?: number,
    pageSize?: number
): Promise<BodyProject> => {
    return await apiService.get('/api/projects', {
        limit: pageSize || '',
        page: page || '',
        projectIds: projectIds ? projectIds.join(',') : '',
    });
};
